import { ButtonBase as MuiButtonBase } from '@material-ui/core';
import React, { forwardRef } from 'react';

const ButtonBase = forwardRef((props, ref) => <MuiButtonBase ref={ref} disableRipple {...props} />);

export default ButtonBase;
